import React from 'react';
import {Scale, Award} from 'lucide-react';

const About = () => {
  return (
    <section id="sobre" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            {/* Photo */}
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-blue-500/20 to-blue-900/20 rounded-3xl blur-2xl"></div>
              <img 
                src="https://static.lumi.new/21/21de02a840282fc681ac26632d1a7714.webp" 
                alt="Dra. Angélica Rabello Turino - Advogada Especialista em Direito do Consumidor"
                className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover border-4 border-white"
              />
              <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-blue-600 to-blue-700 text-white p-6 rounded-2xl shadow-2xl">
                <Scale className="w-12 h-12 mb-2" />
                <div className="text-3xl font-bold">OAB/RJ</div>
                <div className="text-sm">245.846</div>
              </div>
            </div>

            {/* Content */}
            <div>
              <div className="inline-flex items-center space-x-2 bg-blue-500/10 border border-blue-500/30 rounded-full px-4 py-2 mb-6">
                <Award className="w-5 h-5 text-blue-700" />
                <span className="text-blue-700 font-semibold text-sm">Especialista Certificada</span>
              </div>

              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
                Dra. Angélica Rabello Turino
              </h2>

              <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                Advogada especialista em <strong>Direito do Consumidor</strong>, com mais de 15 anos de experiência na defesa de clientes contra abusos e irregularidades praticados por empresas e instituições financeiras.
              </p>

              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Atendimento com excelência técnica e abordagem humanizada na proteção dos direitos do consumidor.
              </p>

              {/* CTA */}
              <a
                href="https://wa.me/5521996853559?text=Olá Dra. Angélica, gostaria de uma orientação jurídica"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z" />
                </svg>
                <span>Agendar Consulta</span>
              </a>

              <p className="text-gray-500 text-sm mt-4">
                📍 Rio de Janeiro - RJ | Atendimento presencial e online
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
